import { render, staticRenderFns } from "./EmailConfigList.vue?vue&type=template&id=559a323e&"
import script from "./EmailConfigList.vue?vue&type=script&lang=ts&"
export * from "./EmailConfigList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports